import React from 'react'

const SupportPage = () => {
  return (
    <main className="container">
      <h1>Support</h1>
      <p>Submit a ticket and view responses from the Obule team.</p>
    </main>
  )
}

export default SupportPage

